
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

interface ExpandButtonProps {
  isExpanded: boolean;
  onClick: () => void;
}

const ExpandButton = ({ isExpanded, onClick }: ExpandButtonProps) => {
  const { t } = useTranslation();
  
  return (
    <button
      onClick={onClick}
      className={cn(
        "w-full flex items-center justify-center",
        "py-1 text-gray-500 hover:text-[#ea384c]", // Reduced padding-y from py-2 to py-1
        "transition-all duration-300",
        "focus:outline-none focus:ring-2 focus:ring-[#ea384c]/20"
      )}
      aria-expanded={isExpanded}
      aria-label={isExpanded ? t('article.showLess') : t('article.showMore')}
    >
      <ChevronDown
        className={cn(
          "h-5 w-5 transition-transform duration-300",
          isExpanded 
            ? "rotate-180" 
            : "animate-bounce-soft" // Add bouncing animation when not expanded
        )}
      />
    </button>
  );
};

export default ExpandButton;
